/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, nthChildIterator, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ANALYTICS OVERVIEW : STYLES --------------- ++++++++++ */
export default theme => ({
	overview: {

		// ----- filters ----- //
		'& .name-filters': {
			opacity: '0',
			marginBottom: pxToEm(30),
			display: 'flex',
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			'& > .group': {
				display: 'flex',
				flexWrap: 'nowrap',
				'&:nth-child(1)': {
					flex: '1',
					'& .dropdown': {
						'&:nth-child(1)': { zIndex: '13' },
						'&:nth-child(2)': { zIndex: '12' },
						'&:nth-child(3)': { zIndex: '11' }
					}
				},
				'&:nth-child(2)': {
					'&:nth-child(1)': { zIndex: '10' }
				},
				'& .dropdown': {
					flex: '1',
					marginBottom: pxToEm(10),
					marginRight: pxToEm(10),
					'&.datepickerdropdown': {
						marginRight: '0'
					}
				}
			}
		},
		// ----- data accuracy callout ----- //
		'& .dataaccuracy':{
			display: 'flex',
			justifyContent: 'flex-end'
		},
		// ----- sections ----- //
		'& .section': {
			marginBottom: pxToEm(70),
			// titles
			'& .copy': {
				opacity: '0',
				'& .title': {
					'& h2': {
						extend: theme.typography.size.medium
					},
					'&.variant-withcontrols':{
						display: 'inline-flex',
						marginBottom: pxToEm(30),
						'& h2':{
							marginRight: pxToEm(15)
						},
						'& .adcontrols':{
							display: 'inline-flex',
							'& .control':{
								fontSize: pxToEm(16),
								height: pxToEm(36),
								minWidth: pxToEm(130),

							}
						}
					}
				}
			},
			// grids
			'& .grid.name-charts': {
				'& .gridset': {
					width: '100%',
					flexWrap: 'wrap',
					alignItems: 'stretch', // remove if bad
					'& .griditem': {
						opacity: '0', // animated in later
						flex: '1', // remove if bad
						padding: replacePXinStringWithEM(`0px 10px 20px`),
						position: 'relative',
						minWidth: pxToEm(350)
					}
				}
			},
			// general charts and tables
			'& .chart': {
				border: '1px solid rgb(236, 240, 247)',
				borderRadius: pxToEm(5),
				padding: pxToEm(20),
				background: theme.color.light.light.swatch,
				'& .data': {
					'& .visualization': {
						height: pxToEm(306),
						'& .state.nodata':{
							marginTop: pxToEm(60)
						}
					}
				},
				'&:hover':{
					boxShadow: '0px 3px 10px 0px rgb(236, 240, 247)'
				}
			},
			'& .tablewrapper': {
				'& .state.nodata': {
					height: pxToEm(301),
					'& .copy': {
						marginTop: pxToEm(-36)
					}
				},
				'& .link': {
					transitionProperty: 'filter', //removed all transitions except filter due to resizing on click
					'&.processing-true':{
						// fontSize: pxToEm(12),
						'& .text':{
							display: 'none'
						},
						'& .loader': {
							fontSize: '28%'
						}
					}
				}
			},


			// ----- section specific overrides ----- //
			'&.name-admetrics': {
				'& .chart': {
					'& .data': {
						'& .visualization': {
							height: pxToEm(270),
							'& .state.nodata':{
								marginTop: pxToEm(60)
							}
						}
					}
				}
			},
			'&.name-contentperformance': {},
			'&.name-embedengagement': {}
		},

		// ..... ANIMATIONS ..... //
		'&.loaded': {
			'& .name-filters': {
				animationName: 'fadeInUp',
				animationDuration: '.2s',
				animationFillMode: 'forwards',
				animationDelay: '.1s',
				position: 'relative',
				zIndex: '1'
			},
			'& .section': {
				'& > .copy': {
					animationName: 'fadeIn',
					animationDuration: '.2s',
					animationFillMode: 'forwards',
				},
				'& .griditem': {
					animationName: 'fadeInUp',
					animationDuration: '.2s',
					animationFillMode: 'forwards',
				},
				'&:nth-child(2)': {
					'& > .copy': { animationDelay: '.1s' },
					'& .griditem': {
						extend: nthChildIterator(3, 0, .1)
					}
				},
				'&:nth-child(3)': {
					'& > .copy': { animationDelay: '.4s' },
					'& .griditem': {
						extend: nthChildIterator(2, .4, .1)
					}
				},
				'&:nth-child(4)': {
					'& > .copy': { animationDelay: '.7s' },
					'& .griditem': {
						extend: nthChildIterator(3, .5, .1)
					}
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: {
		overview: {
			'& .variant-withcontrols':{
				display: 'block !important',
				'& .adcontrols':{
					display: 'block !important'
				}
			},
			'& .name-filters': {
				flexDirection: 'column',
				marginBottom: pxToEm(20),
				justifyContent: 'space-around',
				'& > .group': {
					flexWrap: 'wrap',
					'& .dropdown': {
						flex: '1',
						marginBottom: pxToEm(10),
						marginRight: pxToEm(0),
						maxWidth: '100%'
					},
					'&:nth-child(1)': { flex: '1' },
					'&:nth-child(2)': { flex: '1' }
				}
			}
		}
	},
	[mediaQuery.homepageDateDropdown]: {
		overview: {
			// need to change the datepicker positioning or it moves off screen
			'& .datepickerdropdown': {
				'& .name-dropdown': {
					right: 'auto !important',
					left: '0 !important'
				}
			}
		}
	}
});